import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { makeStyles, useTheme, Snackbar, SnackbarContent, Button } from "@material-ui/core";
import { bindActionCreators } from 'redux';
import ActionCreators from './../../store/actions/index';

const useStyles = makeStyles(theme => ({
    snackbar: {
        background: theme.palette.primary.main
    }
}));

const sessionExpirationComingMessage = (time) => `Twoja sesja wygaśnie w ciągu ${time} ${time === 1 ? 'minuty' : 'minut'}.
                                                    Po tym czasie zostaniesz automatycznie wylogowany`;

const SessionExpirationSnackbar = props => {
    const {closeSessionExpirationSnackbar: onClose, open, timeUntilExpire, renewSession } = props;
    const theme = useTheme();
    const classes = useStyles(theme);

    function reNewSession() {
        renewSession();
        onClose();
    }

    return (
        <Snackbar
            open={open}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right"
            }}
            onClose={onClose}
            autoHideDuration={10000}
        >
            <SnackbarContent
                className={classes.snackbar}
                onClose={onClose}
                message={sessionExpirationComingMessage(timeUntilExpire)}
                action={
                    <Button
                        color="default"
                        size="small"
                        onClick={() => {
                            reNewSession()
                        }}
                    >
                        Przedłuż sesję
                    </Button>
                }
            />
        </Snackbar>
    );
};

const mapStateToProps = (state) => ({
    open: state.authReducer.sessionExpirationSnackbarOpen,
    timeUntilExpire: state.authReducer.sessionExpirationTime
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreators, dispatch);
};


SessionExpirationSnackbar.propTypes = {
    //redux
    open: PropTypes.bool,
    timeUntilExpire: PropTypes.number,
    onClose: PropTypes.func,
    renewSession: PropTypes.func
}

export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(SessionExpirationSnackbar);
